/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BrandOAuthProvidersResult } from '../../models/brand-o-auth-providers-result';

export interface BrandOAuthProvidersGet$Params {
  'Active-Tenant-Identifier': string;
}

export function brandOAuthProvidersGet(http: HttpClient, rootUrl: string, params: BrandOAuthProvidersGet$Params, context?: HttpContext): Observable<StrictHttpResponse<BrandOAuthProvidersResult>> {
  const rb = new RequestBuilder(rootUrl, brandOAuthProvidersGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BrandOAuthProvidersResult>;
    })
  );
}

brandOAuthProvidersGet.PATH = '/brands/oauth-providers';
